export default __webpack_public_path__ + "static/media/GoutamDagar.3db5e998.png";